export enum FormulaTokenTipoEnum {
    Variavel = 0,
    Constante = 1,
    Funcao = 2,
    Parentese = 3,
    Separador = 4,
    Operador = 5
}
